module.exports = __webpack_public_path__ + "assets/img/star-1.5d2edaec.svg";